module.exports = __webpack_public_path__ + "img/floods.ypeka.2885cd47.jpg";